import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const GET_VERSION_SUMMARY_REQUEST = NS + 'GET_VERSION_SUMMARY_REQUEST'
export const GET_VERSION_SUMMARY_SUCCESS = NS + 'GET_VERSION_SUMMARY_SUCCESS'
export const GET_VERSION_SUMMARY_ERROR = NS + 'GET_VERSION_SUMMARY_ERROR'



// WEBPACK FOOTER //
// ./src/modules/process/state/version-summary/type.js